/**
 * Stilenza — kleur en maat kiezen vanuit de vaste koopbalk.
 *
 * De balk toont per optie een keuzeknop met de huidige waarde; tikken klapt de
 * lijst omhoog open. Omhoog, want de balk plakt onderaan het scherm — een lijst
 * die naar beneden opent valt buiten beeld.
 *
 * De opties worden niet nagebouwd in Liquid maar gekloond uit de kiezer boven
 * op de pagina. Daardoor kloppen de kleurvlakjes, de vertaalde kleurnamen en de
 * uitverkochte maten altijd, zonder dat dit bestand die regels hoeft te kennen.
 *
 * Een keuze in de lijst klikt vervolgens de échte knop aan. Alles wat daaraan
 * hangt — variant, prijs, voorraad, de galerij die naar de gekozen kleur
 * springt, de URL — loopt dus via één pad. Dezelfde logica op twee plekken
 * onderhouden is precies hoe de kiezer en de balk uit elkaar gaan lopen.
 *
 * Naïef dupliceren met dezelfde klassen werkt níét: de bestaande handler
 * deselecteert via parentElement, en de regel die "Cream · S" samenstelt telt
 * élke geselecteerde swatch op de pagina. Met een tweede set stond er
 * "Cream · Cream · S · S".
 */
(function () {
  'use strict';

  var bar = document.getElementById('StilenzaStickyATC');
  if (!bar) return;

  var host = bar.querySelector('[data-sticky-opts]');
  var thumb = bar.querySelector('[data-sticky-thumb]');
  if (!host) return;

  var producten = {};
  try {
    producten = JSON.parse(document.getElementById('stilenza-product-data').textContent);
  } catch (e) {
    producten = {};
  }

  var groepen = [];

  /* ── Eén keuzelijst bouwen ─────────────────────────────────────────── */
  function maakGroep(bronnen, soort) {
    var wrap = document.createElement('div');
    wrap.className = 'stil-sticky__select stil-sticky__select--' + soort;

    var knop = document.createElement('button');
    knop.type = 'button';
    knop.className = 'stil-sticky__trigger';
    knop.setAttribute('aria-haspopup', 'listbox');
    knop.setAttribute('aria-expanded', 'false');

    var punt = document.createElement('span');
    punt.className = 'stil-sticky__trigger-dot';
    var tekst = document.createElement('span');
    tekst.className = 'stil-sticky__trigger-text';
    var pijl = document.createElement('span');
    pijl.className = 'stil-sticky__trigger-caret';
    pijl.setAttribute('aria-hidden', 'true');
    pijl.innerHTML = '<svg width="9" height="9" viewBox="0 0 10 10" fill="none">'
      + '<path d="M2.5 6.5L5 3.5L7.5 6.5" stroke="currentColor" stroke-width="1.3"'
      + ' stroke-linecap="round" stroke-linejoin="round"/></svg>';

    if (soort === 'color') knop.appendChild(punt);
    knop.appendChild(tekst);
    knop.appendChild(pijl);

    var lijst = document.createElement('div');
    lijst.className = 'stil-sticky__list';
    lijst.setAttribute('role', 'listbox');
    lijst.hidden = true;

    bronnen.forEach(function (bron) {
      var rij = document.createElement('button');
      rij.type = 'button';
      rij.className = 'stil-sticky__option';
      rij.setAttribute('role', 'option');

      if (soort === 'color') {
        var vlak = document.createElement('span');
        vlak.className = 'stil-sticky__option-dot';
        var hex = bron.dataset.swatchHex;
        if (hex) vlak.style.background = hex;
        rij.appendChild(vlak);
      }

      var naam = document.createElement('span');
      naam.className = 'stil-sticky__option-text';
      naam.textContent = leesLabel(bron, soort);
      rij.appendChild(naam);

      rij.addEventListener('click', function () {
        if (bron.disabled) return;
        bron.click();
        sluitAlles();
        sync();
      });

      lijst.appendChild(rij);
    });

    knop.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = knop.getAttribute('aria-expanded') === 'true';
      sluitAlles();
      if (!open) {
        knop.setAttribute('aria-expanded', 'true');
        lijst.hidden = false;
      }
    });

    wrap.appendChild(knop);
    wrap.appendChild(lijst);
    groepen.push({ soort: soort, wrap: wrap, knop: knop, lijst: lijst, punt: punt, tekst: tekst, bronnen: bronnen });
    return wrap;
  }

  function leesLabel(bron, soort) {
    // data-label eerst, voor kleur én maat: dat is de vertaalde weergavenaam.
    // data-value is de ruwe optiewaarde waarmee de variant wordt opgezocht, en
    // die staat op bijna de helft van de catalogus nog in het Engels omdat
    // Shopify er geen vertaling op toestaat.
    if (bron.dataset.label) return bron.dataset.label;
    if (soort === 'color') return bron.dataset.value || '';
    // Terugval: de knop bevat ook nog de centimeter-regel, en die hoort niet in
    // een keuzelijst van deze hoogte.
    return bron.dataset.value || (bron.textContent || '').trim().split('\n')[0];
  }

  function sluitAlles() {
    groepen.forEach(function (g) {
      g.knop.setAttribute('aria-expanded', 'false');
      g.lijst.hidden = true;
    });
  }

  /* ── Opbouw ────────────────────────────────────────────────────────── */
  function bouw() {
    var swatches = document.querySelectorAll('.stil-pdp__swatches .stil-pdp__swatch');
    var maten = document.querySelectorAll('.stil-pdp__size');
    if (!swatches.length && !maten.length) return;

    host.innerHTML = '';
    if (swatches.length) host.appendChild(maakGroep([].slice.call(swatches), 'color'));
    if (maten.length) host.appendChild(maakGroep([].slice.call(maten), 'size'));
    bar.classList.add('has-options');
  }

  /* ── Spiegelen ─────────────────────────────────────────────────────── */
  function sync() {
    groepen.forEach(function (g) {
      var gekozenIndex = -1;
      g.bronnen.forEach(function (bron, i) {
        if (bron.classList.contains('is-selected')) gekozenIndex = i;
        var rij = g.lijst.children[i];
        if (!rij) return;
        var uit = bron.classList.contains('is-sold-out') || bron.disabled;
        rij.classList.toggle('is-selected', bron.classList.contains('is-selected'));
        rij.classList.toggle('is-sold-out', uit);
        rij.disabled = uit;
        rij.setAttribute('aria-selected', bron.classList.contains('is-selected') ? 'true' : 'false');
      });

      // Bewust niet 'bron': die naam is hierboven al de lusvariabele van de
      // forEach, en dan verduistert deze declaratie hem voor de hele functie.
      // Precies het patroon dat de maatkeuze sloopte.
      var gekozenBron = gekozenIndex >= 0 ? g.bronnen[gekozenIndex] : null;
      g.tekst.textContent = gekozenBron ? leesLabel(gekozenBron, g.soort) : '';
      if (g.soort === 'color') {
        var hex = gekozenBron && gekozenBron.dataset.swatchHex;
        g.punt.style.background = hex || 'transparent';
        g.punt.style.display = hex ? '' : 'none';
      }
    });

    // Het duimnagelbeeld volgt de gekozen kleur. Heeft de variant geen eigen
    // foto, dan blijft staan wat er stond — beter dan terugvallen op de
    // hoofdfoto, want dan springt hij bij elke maatkeuze heen en weer.
    if (thumb) {
      var v = huidigeVariant();
      if (v && v.featured_image && v.featured_image.src) {
        var src = v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
        if (thumb.getAttribute('src') !== src) thumb.setAttribute('src', src);
      }
    }
  }

  function huidigeVariant() {
    // Niet op [data-variant-id] alleen: dat attribuut staat ook op elke
    // maatknop en op de kaartjes in de galerij — 34 elementen in totaal, en
    // querySelector pakte er een zonder waarde. Het verborgen invoerveld is
    // het enige dat de gekozen variant draagt.
    var input = document.querySelector('input[name="id"][data-variant-id]');
    if (!input || !producten.variants) return null;
    var id = parseInt(input.value, 10);
    for (var i = 0; i < producten.variants.length; i++) {
      if (producten.variants[i].id === id) return producten.variants[i];
    }
    return null;
  }

  /* ── Starten ───────────────────────────────────────────────────────── */
  function start() {
    bouw();
    if (!groepen.length) return;

    // Ook meelopen als iemand de kiezer erboven gebruikt in plaats van de balk.
    // Deze luisteraars worden ná die van de kiezer aangemeld, dus ze draaien
    // pas als de variant al is bijgewerkt.
    document.querySelectorAll('.stil-pdp__swatch, .stil-pdp__size, .stil-pdp__gallery-color-dot')
      .forEach(function (b) { b.addEventListener('click', sync); });

    document.addEventListener('click', function (e) {
      if (!host.contains(e.target)) sluitAlles();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') sluitAlles();
    });
    // Hier stond een scroll-luisteraar die de lijst dichtdeed. Dat sloopte hem
    // op een telefoon: de adresbalk klapt bij de minste beweging in of uit en
    // vuurt scroll, dus de lijst ging dicht op hetzelfde moment dat je hem
    // opende — het leek alsof de knop niet werkte. De reden erachter klopte
    // bovendien niet: de lijst zit ín een position:fixed balk en schuift dus
    // sowieso niet weg van de pagina.

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
